import { HttpClient } from '../HttpClient';
/**
 * * Post Employees
 */
export const PostEmployees = async (projectId, postEmployeesData) => {
  try {
    const { data } = await HttpClient.post(`api/projects/${projectId}/Employees`, { ...postEmployeesData });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
